import type { ReduxStore } from "../../reducers/root_reducer";

const getUser = (state: ReduxStore, props) => state.user;

export default getUser;
